import { createElement } from 'react';
import './index.scss';
import TextDescriptionDetailListItem from './text-description-detail-list-item';
const TextDescriptionDetailList = ({ dataList, fixedData, labelPosition, onClick, ...otherProps }) => {
    const _otherProps = otherProps || {};
    console.log('dataList', dataList);
    const renderListItems = (data) => {
        return Object.entries(data).map(([key, value], index) => (createElement(TextDescriptionDetailListItem, { key: index, label: key, value: String(value), labelPosition: labelPosition, onClick: onClick })));
    };
    const getContent = () => {
        if (dataList && Object.keys(dataList).length > 0) {
            return renderListItems(dataList);
        }
        if (fixedData && Object.keys(fixedData).length > 0) {
            return renderListItems(fixedData);
        }
        return createElement("div", { className: "no-data" }, "\u6682\u65E0\u6570\u636E");
    };
    return (createElement("div", { className: "text-description-detail-list", ..._otherProps }, getContent()));
};
TextDescriptionDetailList.displayName = 'TextDescriptionDetailList';
export default TextDescriptionDetailList;
